/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Vehicle_SinceInputs */

const fr_map_vehicle_since = /** @type {(inputs: Map_Vehicle_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depuis`)
};

const en_map_vehicle_since = /** @type {(inputs: Map_Vehicle_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`since`)
};

/**
* | output |
* | --- |
* | "since" |
*
* @param {Map_Vehicle_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_vehicle_since = /** @type {((inputs?: Map_Vehicle_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Vehicle_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_vehicle_since(inputs)
	return en_map_vehicle_since(inputs)
});